<template>
	<div :class="scrollTop==0?'content':'contents'">
		<div class="box">
			<router-link to="HomePage"><img
					:src="scrollTop==0?'../../../static/img/fwwl.png':'../../../static/img/fwwl2.png'"
					alt=""></router-link>
			<div class="btns">
				<div class="Outside">
					<router-link to="HomePage"><span>首页</span></router-link>

				</div>
				<div class="Outside">
					<router-link to="Electricity"><span>产品中心</span></router-link>
					<div class="boxs" style="width: 500px;">
						<ul>
							<li @click="goProduct(false,1)">工业物联</li>
							<li @click="goProduct(true,1)">泛物网络售电支持平台</li>
							<li @click="goProduct(true,2)">泛物网络数据监控平台</li>
							<li @click="goProduct(true,3)">泛物网络物联网中心平台</li>
						</ul>
						<ul>
							<li @click="goProduct(false,2)">智慧水务</li>
							<li @click="goProduct(true,4)">泛物网络城市供水管网检测平台</li>
						</ul>
					</div>
				</div>
				<div class="Outside">
					<router-link to="Information"><span>解决方案</span></router-link>
					<div class="boxs" style="width: 300px;">
						<ul>
							<li @click="goSolution()">行业解决方案</li>
							<li @click="goSolution(1)">泛物网络售电支持平台</li>
							<li @click="goSolution(2)">泛物网络数据监控平台</li>
							<li @click="goSolution(3)">泛物网络物联网中心平台</li>
							<li @click="goSolution(4)">泛物网络城市供水管网检测平台</li>
						</ul>
					</div>
				</div>
				<div class="Outside">
					<router-link to="Platform"><span>泛物网络</span></router-link>
					<div class="boxs" style="width: 200px;">
						<ul>
							<li @click="goFanwu()()">泛物网络</li>
							<li @click="goFanwu(1)">平台优势</li>
							<li @click="goFanwu(2)">设备管理</li>
							<li @click="goFanwu(3)">可视化展示</li>
							<li @click="goFanwu(4)">数据分析</li>
						</ul>
					</div>
				</div>
				<div class="Outside">
					<router-link to="Info"><span>行业资讯</span></router-link>
				</div>
				<div class="Outside">
					<router-link to="aboutus"><span>关于我们</span></router-link>
				</div>
				<div class="Outside" style="cursor: pointer;margin-left: 25px;" @click="gofanwu">
					<div ><span>登录</span></div>
				</div>
				<div class="Outside" style="cursor: pointer;margin-left: 25px;" @click="gonewfanwu">
					<div style=""><span>新登录</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				scrollTop: 0,
				activeIndex: "1",
				activeIndex2: "1",
				address: "https://fw.fiotcp.com:17324/v1/",
				Loop: null,
				timer0: '', //第一次点击的时间
				timer4: '', //第四次点击的时间
				num: 0
			}
		},
		mounted() {
			window.addEventListener('scroll', this.getScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		methods: {
			// 跳转后台管理
			gofanwu(){
				// window.location.href = 'https://fw.fiotcp.com:17324/v1/';  
				window.location.href = 'https://fiotcp.com:17396/v1/#/login';
				
			},
			// 跳转新后台管理
			gonewfanwu(){
				window.location.href = 'https://fiotn.com:9999/';  
			},
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			},
			zhuce() {
				this.num++
				if (this.num == 1) {
					this.timer0 = new Date().getTime() / 1000
				}
				if (this.num == 4) {
					this.timer4 = new Date().getTime() / 1000
					if (this.timer4 - this.timer0 <= 2) {
						//this.isShow=!this.isShow
						this.num = 0
						this.centerDialogVisible = true
						window.open("Register")
					} else {
						this.num = 0
					}
				}
			},
			//监听滚动
			getScroll() {
				this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log(this.scrollTop);
				if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 300) {

				}
			},
			// 产品中心
			goProduct(Jump, is) {
				// 判断跳转商品内页
				if (Jump) {
					if (this.$route.name == 'Product') {
						this.$router.replace({
							path: '/refresh?tid=' + is,
						})
					} else {
						this.$router.push({
							name: 'Product',
							query: {
								tid: is
							}
						});
					}
				} else {
					if (this.$route.name == 'Electricity') {
						this.$router.replace({
							path: '/refresh?tid=' + is,
						})
					} else {
						this.$router.push({
							name: 'Electricity',
							query: {
								tid: is
							}
						});
					}
				}
			},
			// 解决方案
			goSolution(Jump) {
				if (Jump) {
					if (this.$route.name == 'Information') {
						this.$router.replace({
							path: '/refresh?tid=' + Jump,
						})
					} else {
						this.$router.push({
							name: 'Information',
							query: {
								tid: Jump
							}
						});
					}
				} else {
					this.$router.push({
						name: 'Information'
					});
				}
			},
			// 泛物网络
			goFanwu(Jump) {
				if (Jump) {
					if (this.$route.name == 'Platform') {
						this.$router.replace({
							path: '/refresh?tid=' + Jump,
						})
					} else {
						this.$router.push({
							name: 'Platform',
							query: {
								tid: Jump
							}
						});
					}
				} else {
					this.$router.push({
						name: 'Platform'
					});
				}
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.content {
		width: 100%;
		// padding: 10px 0;
		position: fixed;
		top: 0;
		color: #FFFFFF;
		z-index: 999999;
		transition: 0.3s;
	}

	.btns {
		.Outside {
			display: inline-block;
			position: relative;

			&:hover .boxs {
				display: block;
			}

			&::after {
				content: '';
				position: absolute;
				top: 65px;
				bottom: 0;
				left: 50%;
				width: 0;
				height: 2px;
				background: #2a8de3;
				transform: translateX(-50%);
				transition: 0.5s;
			}

			&:hover {
				color: #2a8de3;
				transition: 0.5s;

				&::after {
					width: 100%;
				}
			}

			.boxs {
				display: none;
				position: absolute;
				top: 67px;
				background-color: rgba(31, 31, 31, 0.8);
				padding: 30px 20px;

				ul {
					width: auto;
					float: left;

					li {
						color: #FFFFFF;
						font-size: 16px !important;
						margin-right: 30px;
						margin-bottom: 16px;
						font-family: inherit;
						line-height: 1.1;
						white-space: nowrap;
						cursor: pointer;

						&:first-child {
							font-weight: 600;
							color: #2a8de3;
						}

						&:hover {
							color: #2a8de3;
						}

						&:last-child {
							margin: 0;
						}
					}
				}
			}

			span {
				color: #FFFFFF;
				padding: 20px 15px;
			}
		}
	}

	.contents {
		width: 100%;
		// padding: 10px 0;
		position: fixed;
		top: 0;
		background-color: #fff;
		z-index: 999999;
		transition: 0.3s;
		color: #000000;
		box-shadow: 0 0 10px #cccccc;

		.btns span {
			color: #000000;
		}
	}

	.box {
		width: 80%;
		margin: 0 auto;
	}

	.box img {
		width: 160px;
		height: 50px;
		float: left;
		margin-top: 8px;
	}

	.btns {
		float: right;
	}

	.btns span {
		margin-top: 5px;
		display: inline-block;
		padding: 10px 20px;
		font-size: 16px;
		position: relative;

	}
</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue